import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    analytics: any;
  }
}

export const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Basic check to ensure analytics is loaded
    if (window.analytics) {
      window.analytics.page();
    }
  }, [location]);

  return null;
};
